<template>
    <div id="aulas">
        <v-app>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="18" class="titulo">
                    Aulas Virtuales
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="22" class="cuerpo">

                    Las <strong>aulas virtuales</strong> son un nuevo concepto en <strong>educación a
                    distancia</strong>. La <strong>educación virtual</strong> facilita el manejo de la información
                    y de los contenidos del tema que se quiere tratar y está mediada por las <strong>tecnologías
                    de la información y la comunicación</strong> que proporcionan <strong>herramientas de
                    aprendizaje</strong> más estimulantes y motivadoras que las tradicionales.-
                    <br><br>

                    <v-alert type="warning" color="orange" :value="true">
                        Para acceder, use sus datos del Panel Docente.
                    </v-alert>
                    <br><br>

                     <el-row>
                        <el-col :xs="24" :sm="12" style="background:#eee; border-radius:5px">
                            <v-text-field ref="Buscar" v-model="Search" append-icon="search" label="Buscar" single-line hide-details style="padding:10px"></v-text-field>
                        </el-col>
                    </el-row>
                    <v-data-table :headers="Headers" :items="Comisiones" :search="Search" :pagination.sync="Pagination" style="margin-top:30px">
                         <template slot="no-data">
                                <el-col>
                                 <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>                                 
                               <el-col class="cargandomsg"> Cargando Datos </el-col>
                                </el-col>                               
                        </template>
                        <template slot="items" slot-scope="props">
                            <td colspan="3" class="no_results_msj" v-if="props.item.resultado==0">
                                No se encontraron resultados
                            </td>
                            <tr v-else>
                                <td>{{ props.item.idComision }} </td>
                                <td>{{ props.item.Nombre }}     </td>
                                <td>
                                    <center>
                                        <a v-if="props.item.idAulaVirtual"   :href="'https://plataforma.educaciondigitaltuc.gob.ar/moodle/course/view.php?id='+props.item.idAulaVirtual+''"    class="el-button el-button--primary el-button--mini" target="_blank" style="margin-bottom:5px">Acceder</a>
                                        <span v-if="props.item.idAulaVirtual && props.item.idCampus">&nbsp;&nbsp;</span>
                                        <a v-if="props.item.idCampus"        :href="'https://campus.educaciontuc.gov.ar/lms/course/view.php?id='+props.item.idCampus+''"                       class="el-button el-button--primary el-button--mini" target="_blank"                          >Acceder</a>
                                    </center>
                                </td>                             
                            </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            No se encontraron resultados
                        </v-alert>
                    </v-data-table>
                </el-col>
            </el-row>
        </v-app>
    </div>
</template>



<script>
    import axios from 'axios'

    export default
    {   data()
        {   return {
                Comisiones: [],
                Search:     '',                
                Pagination: { 
                    descending: true,
                    rowsPerPage: 10,
                    sortBy: 'id' 
                },
                Headers: [{
                        text: 'Com ',
                        value: 'idComision'
                    },
                    {
                        text: 'Capacitación ',
                        value: 'Nombre'
                    },
                    {
                        text: 'Acceder ',
                        value: 'idCampus'
                    }
                ],
            }
        },


        methods:
        {   SortIdComision: function(a,b)
            {   return parseInt(a.idComision) > parseInt(b.idComision);
            }
        },


        beforeMount( )
        {   if (!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/a_v.php', params, {headers: headers})
                    .then(response => {
                        const datos     = response.data
                        if(datos==null)
                        {    
                            this.Comisiones     = [ {"resultado": 0}];                       
                        }
                        else
                        {
                            this.Comisiones = datos['Comisiones'];                            
                        }

                        
                           
                    })
                   /* .catch(e => {})*/
            }
        },

        mounted()
        {   this.$nextTick(this.$refs.Buscar.focus);
        }
    };
</script>



<style>
    .v-datatable thead tr th, .v-datatable thead tr td
    {   background: #00B5FF !important;
        text-align: center !important;
        color: #fff !important;
        font-weight: bold !important;
    }

    table tr:hover td
    {   background: #EEF1F6 !important;
    }
    .no_results_msj
    {
        text-align: center;
        width: 100%!important;         
        font-weight: 600!important;        
    }
     .cargandomsg
    {
            font-weight: 600!important;
            padding-bottom: 1%!important;

    }
</style>